import { fromZonedTime } from 'date-fns-tz';
import { formatDistance } from 'date-fns';

import { parseEnvironmentTimezone } from '@/react/portainer/environments/update-schedules/common/utils';

import { ScheduleEnvironment } from './types';

export function duration(scheduleEnvironment: ScheduleEnvironment) {
  if (!scheduleEnvironment.scheduledTime) {
    return null;
  }
  // Determine the timezone to use
  const timeZone = parseEnvironmentTimezone(
    scheduleEnvironment.environment.LocalTimeZone
  );
  // Convert scheduledTime string to Date in the proper timezone
  const scheduledDate = fromZonedTime(
    scheduleEnvironment.scheduledTime,
    timeZone
  );

  const status =
    scheduleEnvironment.edgeStack?.Status?.[
      scheduleEnvironment.environment.Id
    ] ?? null;

  const hasStarted = new Date() > scheduledDate;
  if (!hasStarted) {
    // If the update has not started yet, return a message indicating that
    return `Duration: --`;
  }
  const startDate = scheduleStartDate(scheduleEnvironment);
  // Handle the case where the update has not yet started.
  if (!status) {
    return `Duration: ${formatDistance(startDate, new Date())}`;
  }
  // Get the last update timestamp (assuming lastStatus.Time is in seconds)
  const lastStatus = status.Status[status.Status.length - 1];
  if (!lastStatus) {
    return `Duration: ${formatDistance(startDate, new Date())}`;
  }

  const lastUpdateDate = new Date(lastStatus.Time * 1000);

  return `Duration: ${formatDistance(startDate, lastUpdateDate)}`;
}

export function mostRecentDate(...dates: Date[]): Date {
  let mostRecent = new Date(0);
  dates.forEach((date) => {
    if (date > mostRecent) {
      mostRecent = date;
    }
  });

  return mostRecent;
}

export function scheduleStartDate(
  scheduleEnvironment: ScheduleEnvironment
): Date {
  if (!scheduleEnvironment.scheduledTime) {
    return new Date(0);
  }
  // Determine the timezone to use
  const timeZone = parseEnvironmentTimezone(
    scheduleEnvironment.environment.LocalTimeZone
  );
  // Convert scheduledTime string to Date in the proper timezone
  const scheduledDate = fromZonedTime(
    scheduleEnvironment.scheduledTime,
    timeZone
  );

  const createdDate = new Date(scheduleEnvironment.created * 1000);
  const updatedDate = new Date(scheduleEnvironment.updated * 1000);
  if (!scheduleEnvironment.updated) {
    return mostRecentDate(createdDate, scheduledDate);
  }

  return mostRecentDate(createdDate, updatedDate, scheduledDate);
}
